module.exports = __webpack_public_path__ + "static/img/logo.b1dc045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uoofox/logo.png
// module id = sSFV
// module chunks = 1